import React from 'react';
import Modal from '@tekion/tekion-components/src/molecules/Modal';
import styles from './ConfirmationDialog.module.scss';
const ConfirmationDialog = _ref => {
  let {
    visible,
    title,
    submitBtnText,
    onSubmit,
    onCancel,
    bodyMessage,
    secondaryBtnLoading,
    loading,
    okButtonProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Modal, {
    visible: visible,
    centered: true,
    title: __(title),
    width: 500,
    destroyOnClose: true,
    submitBtnText: __(submitBtnText),
    onSubmit: () => onSubmit(),
    onCancel: () => onCancel(false),
    className: styles.confirmationDialog,
    secondaryBtnLoading: secondaryBtnLoading,
    loading: loading,
    okButtonProps: okButtonProps
  }, bodyMessage);
};
export default ConfirmationDialog;